import React from 'react';
import moment from 'moment';

const Convo = ({ messages, user }) => {
    // Group messages by date
    const groupMessagesByDate = (msgs) => {
        const groups = {};
        msgs.forEach(msg => {
            const date = moment(msg.timestamp || msg.time, 'hh:mm A').format('DD/MM/YYYY');
            if (!groups[date]) groups[date] = [];
            groups[date].push(msg);
        });
        return groups;
    };

    const grouped = groupMessagesByDate(messages);
    const dates = Object.keys(grouped).sort((a, b) => moment(a, 'DD/MM/YYYY').diff(moment(b, 'DD/MM/YYYY')));

    // Simple markdown support
    const formatText = (text) => {
        if (!text) return '';
        return text
            .replace(/\*(.*?)\*/g, '<strong class="font-weight-bold">$1</strong>')
            .replace(/_(.*?)_/g, '<em class="font-italic">$1</em>');
    };

    return (
        <div className="d-flex flex-column pb-3">
            {dates.map(date => (
                <div key={date} className="w-100">
                    <div className="date-separator text-center my-4 relative">
                        <span className="bg-white px-3 py-1 rounded-pill border shadow-sm x-small font-weight-bold text-uppercase text-muted letter-spacing-1">
                            {moment(date, 'DD/MM/YYYY').calendar(null, {
                                sameDay: '[Today]',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD, MMM YYYY'
                            })}
                        </span>
                    </div>

                    {grouped[date].map(msg => (
                        <div key={msg.id} className={`message-container d-flex mb-2 px-1 ${msg.sender === 'me' ? 'justify-content-end' : 'justify-content-start'}`}>
                            <div className={`message-bubble shadow-sm relative ${msg.sender === 'me' ? 'bg-sent rounded-bubble-sent' : 'bg-white rounded-bubble-received border border-indigo-50'}`}>
                                <div
                                    className={`message-content mb-1 ${msg.sender === 'me' ? 'text-dark-80' : 'text-dark'}`}
                                    dangerouslySetInnerHTML={{ __html: formatText(msg.content) }}
                                />
                                <div className="message-meta d-flex justify-content-end align-items-center mt-1">
                                    <small className={`${msg.sender === 'me' ? 'text-dark-40' : 'text-muted'} x-small font-weight-500 mr-2`}>
                                        {msg.time}
                                    </small>
                                    {msg.sender === 'me' && (
                                        <i className={`fas fa-check-double ${msg.status === 'read' ? 'text-royal-blue' : 'opacity-30'}`} style={{ fontSize: '11px' }} />
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default Convo;
